import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Badge from '../../../UniformComponents/Badge'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'
import LinkButton from '../../../UniformComponents/LinkButton'
import Input from '../../form/Input'

import './collapsibleMatrix.scss'

const CollapsibleMatrix = observer(({ chartData, exhibitorName, numResponses }) => {
    const [collapsed, setCollapsed] = useState(true)
    const {
        disengaged, progressive, prospector, recalibrator,
    } = chartData?.surveyDataIds ?? {}
    if (!chartData || chartData.error) {
        return (
            <div className="collapsibleMatrix">
                <div className="titleContainer">
                    <div className="flex">
                        <div className="titleIcon">
                            <i className="fa-sharp fa-light fa-code-merge" />
                        </div>
                        <div className="title">
                            <span className="strong">{exhibitorName}</span>
                            {' '}
                            left
                            {' '}
                            <span className="strong">
                                {numResponses}
                                {' '}
                                response
                                {numResponses > 1 ? 's' : ''}
                            </span>
                            , mapped across
                            {' '}
                            0
                            {' '}
                            segment on the Sales Intelligence Matrix
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    const expandedSection = () => (
        <div className={`matrixWidget ${collapsed ? 'collapsed' : ''}`} style={{ position: 'relative' }}>
            <div className="yLabel" style={{ position: 'absolute' }}>
                Commitment
                →
            </div>
            <div className="xLabel" style={{ position: 'absolute' }}>
                Exhibitor Execution
                →
            </div>
            <div className="matrixGrid">
                <div className={`cell recalibrator ${recalibrator?.length ? 'hasValue yellow' : ''}`}>
                    <div className="cellLabel">
                        <div className="yellow cellMarker" />
                        Committed Under-performers
                    </div>
                    {recalibrator?.length ? (
                        <div className="cellValue">
                            <span className="numResponses">{recalibrator.length}</span>
                            {' '}
                            response
                            {recalibrator.length > 1 ? 's' : ''}
                        </div>
                    ) : null}
                </div>
                <div className={`cell progressive ${progressive?.length ? 'hasValue green' : ''}`}>
                    <div className="cellLabel">
                        <div className="green cellMarker" />
                        Committed Performers
                    </div>
                    {progressive?.length ? (
                        <div className="cellValue">
                            <span className="numResponses">{progressive.length}</span>
                            {' '}
                            response
                            {progressive.length > 1 ? 's' : ''}
                        </div>
                    ) : null}
                </div>
                <div className={`cell disengaged ${disengaged?.length ? 'hasValue red' : ''}`}>
                    <div className="cellLabel">
                        <div className="red cellMarker" />
                        Sceptical Under-performers
                    </div>
                    {disengaged?.length ? (
                        <div className="cellValue">
                            <span className="numResponses">{disengaged.length}</span>
                            {' '}
                            response
                            {disengaged.length > 1 ? 's' : ''}
                        </div>
                    ) : null}
                </div>
                <div className={`cell prospector ${prospector?.length ? 'hasValue orange' : ''}`}>
                    <div className="cellLabel">
                        <div className="orange cellMarker" />
                        Sceptical Performers
                    </div>
                    {prospector?.length ? (
                        <div className="cellValue">
                            <span className="numResponses">{prospector.length}</span>
                            {' '}
                            response
                            {prospector.length > 1 ? 's' : ''}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    )

    return (
        <div className="collapsibleMatrix">
            <div className="titleContainer">
                <div className="flex">
                    <div className="titleIcon">
                        <i className="fa-sharp fa-light fa-code-merge" />
                    </div>
                    <div className="title">
                        <span className="strong">{exhibitorName}</span>
                        {' '}
                        left
                        {' '}
                        <span className="strong">
                            {numResponses}
                            {' '}
                            response
                            {numResponses > 1 ? 's' : ''}
                        </span>
                        , mapped across
                        {' '}
                        {Object.keys(chartData?.surveyDataIds).length}
                        {' '}
                        segment on the Sales Intelligence Matrix
                    </div>
                </div>
                <div className="badges">
                    {recalibrator?.length ? (
                        <div className="valueBadge">
                            <div className="yellow marker" />
                            <div>
                                Committed Under-performers
                            </div>
                            <div>
                                {recalibrator?.length}
                            </div>
                        </div>
                    ) : null}
                    {progressive?.length ? (
                        <div className="valueBadge">
                            <div className="green marker" />
                            <div>
                                Committed Performers
                            </div>
                            <div>
                                {progressive?.length}
                            </div>
                        </div>
                    ) : null}
                    {disengaged?.length ? (
                        <div className="valueBadge">
                            <div className="red marker" />
                            <div>
                                Sceptical Under-performers
                            </div>
                            <div>
                                {disengaged?.length}
                            </div>
                        </div>
                    ) : null}
                    {prospector?.length ? (
                        <div className="valueBadge">
                            <div className="orange marker" />
                            <div>
                                Sceptical Performers
                            </div>
                            <div>
                                {prospector?.length}
                            </div>
                        </div>
                    ) : null}
                    <div className="toggleBadge" onClick={() => setCollapsed(!collapsed)}>
                        {collapsed ? 'Show' : 'Hide'}
                        {' '}
                        matrix
                        <span><i className={`fa-solid fa-chevron-${collapsed ? 'down' : 'up'}`} /></span>
                    </div>
                </div>
            </div>
            {expandedSection()}
        </div>
    )
})

export default CollapsibleMatrix
